/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid */
import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './get-styles';


/**
 * This component renders a button that will perform an onclick event
 * when the user clicks it and will open an apex help pop up
 *
 * @param {*} props - props
 * @returns {ReactNode} HelpLinkWithOnClick
 */
export const HelpLinkWithOnClick = (props) => {
  const {
    text,
    ariaLabel,
    className,
    query,
    onClick,
    tabIndex,
  } = props;

  const classes = useDefaultStyles(getStyles);
  const hiddenButton = useRef();

  const onClickAndOpen = useCallback(() => {
    onClick();
    hiddenButton.current.click();
  }, [onClick]);

  return (
    <span>
      <button
        className={classNames(classes.helpLink, className, 'help-topic-link')}
        onClick={onClickAndOpen}
        aria-label={ariaLabel || text}
        tabIndex={tabIndex}
      >
        {text}
      </button>
      <button className="HelpTopic" query={query} hidden ref={hiddenButton} />
    </span>
  );
};

HelpLinkWithOnClick.propTypes = {
  text: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  query: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  tabIndex: PropTypes.number,
};

HelpLinkWithOnClick.defaultProps = {
  ariaLabel: null,
  className: '',
  tabIndex: undefined,
};
